import React from 'react';
import { Comment } from '../CommentCard/Comment';
import { useGetRepliesQuery } from '../../apis';
import { Spinner, SpinnerVariants } from '../../UI';
import type { CommentResponse } from '../../types';

interface RepliesProps {
    commentId: string;
    handleAnswer: (commentId: string, answer: boolean) => void;
    canAct?: boolean;
    onRequireAuth?: () => void;
}

export const Replies: React.FC<RepliesProps> = (props) => {
    const commentId = props.commentId;
    const handleAnswer = props.handleAnswer;
    const { canAct, onRequireAuth } = props;

    const { data, isLoading } = useGetRepliesQuery({ commentId });

    if (isLoading) {
        return (
            <div className='flex justify-center'>
                <Spinner variant={SpinnerVariants.SMALL_CIRCLE} />
            </div>
        );
    }

    const safeReplies: CommentResponse[] = Array.isArray(data) ? data : [];

    return (
        <div>
            {safeReplies.map((comment) => (
                <Comment
                    data={comment}
                    onAnswer={handleAnswer}
                    canAct={canAct}
                    onRequireAuth={onRequireAuth}
                    key={comment._id}
                />
            ))}
        </div>
    );
};
